$(() => {

    'use strict';

    /*============================================
        Initializations
    ==============================================*/

    // AJAX
    require('./modules/ajax.js');

    // Service Worker
    require('./modules/worker.js');

    // Bootstrap
    require('./modules/bootstrap.js');

    // Datatable
    require('./modules/datatable.js');

    /*============================================
        Event Listeners
    ==============================================*/

    // Unused links
    $(document).on('click', 'a[href="#"]', function (e) {
        e.preventDefault();
    });

    // Phone Number Dropdown
    if ($('.input-phone:not(.ignore)').length > 0) {
        $('.input-phone:not(.ignore)').each((index, element) => {
            $(element).customPhoneInput();
        });
    }

    // Preloader
    $(window).on('load', function () {
        if (!window.forceLoader) {
            $(window).trigger('scroll');
            $('body').attr('data-loaded', true);
        }
    });

    setTimeout(() => {
        if (!window.forceLoader) {
            $('body').attr('data-loaded', true);
        }
    }, 1500);

    // QR Generation
    if ($('[data-qr]').length > 0) {
        $('[data-qr]').each((index, element) => {
            new QRCode(element, {
                text: $(element).data('qr'),
                width: $(element).attr('width') || 256,
                height: $(element).attr('height') || 256,
                colorDark: "#000",
                colorLight: "#fff",
                correctLevel: QRCode.CorrectLevel.H,
            });
        });
    }

    // Redirect to anchor
    if (!!window.location.hash.trim()) {
        var target = $('a[data-bs-target="' + window.location.hash + '"]');
        if (target.length > 0) {
            target.each((index, element) => {
                $(element).tab('show');
            })
        }
    }

    // Selection
    if ($('.selection:not(.ignore)').length > 0) {
        $('.selection:not(.ignore)').each((index, element) => {
            $(element).customSelection();
        });
    }

    // Prices Precision
    $(document).on('change', 'input[data-fixed]', function () {
        $(this).val($.parseNumber($(this).val()).toFixed($(this).data('fixed')));
    });

    // Copy To Clipboard
    if ($('[data-copy]').length > 0) {
        $('[data-copy]').each((index, element) => {
            $(element).on('click', function () {
                $.copyToClipboard($(this).data('copy'));
            })
        });
    }

    // Event - Set cookie referred by
    var url = window.location.search;
    var urlSearchParams = new URLSearchParams(url);

    if (urlSearchParams.get('referred_by')) {
        $.setCookie('referred_by', urlSearchParams.get('referred_by'));
    }

    // Event - Refresh Wallet
    var findFromWallets = function (wallets, providerId, walletId) {
        if (walletId) {
            return wallets.find(wallet => wallet.id == walletId);
        }

        if (providerId) {
            return wallets.find(wallet => wallet.provider_id == providerId)
        }

        return null;
    }

    $(document).on('click', '[data-event="refresh-wallet"]', function () {
        var node = $(`<div class="loader-wallet">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>`);

        $('[data-event="credit"]').html(node.clone());
        $('[data-event="turnover"]').html(node.clone());
        $('[data-event="current-turnover"]').html(node.clone());

        $.ajax({
            type: 'POST',
            url: '/wallets/refresh',
            beforeSend: function () {
                //
            },
            success: function (e) {
                $('[data-event="credit"]').each((index, element) => {
                    var providerId = $(element).closest('[data-provider]').data('provider'),
                        walletId = $(element).closest('[data-wallet]').data('wallet'),
                        wallet = findFromWallets(e.data.wallets, providerId, walletId);

                    $(element).html($.formatNumber(wallet?.credit || 0));
                });

                $('[data-event="turnover"]').each((index, element) => {
                    var providerId = $(element).closest('[data-provider]').data('provider'),
                        walletId = $(element).closest('[data-wallet]').data('wallet'),
                        wallet = findFromWallets(e.data.wallets, providerId, walletId);

                    $(element).html($.formatNumber(wallet?.turnover || 0));
                });

                $('[data-event="current-turnover"]').each((index, element) => {
                    var providerId = $(element).closest('[data-provider]').data('provider'),
                        walletId = $(element).closest('[data-wallet]').data('wallet'),
                        wallet = findFromWallets(e.data.wallets, providerId, walletId);

                    $(element).html($.formatNumber(wallet?.current_turnover || 0));
                });
            },
            error: function (e) {
                $.handleError(e, () => {
                    $.focusOnError(e);
                });
            },
        });
    });

    // Event - User Logout
    $(document).on('click', '[data-event="logout"]', function (e) {
        $.ajax({
            type: 'POST',
            url: '/logout',
            success: function () {
                $.redirectTo('/');
            },
        });
    });
});
